<template>
  <section class="gardenManagementPage">
    <!-- <g-breadcrumb bread="视频列表" /> -->
    <SearchForm class="dis-flex flex-x-between flex-y-center">
      <el-form ref="ref_searchForm" :inline="true" :model="searchForm" label-width="80px">
        <el-form-item>
          <el-input v-model.trim="searchForm.regName" placeholder="请输入来访人员姓名" />
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="searchForm.regPhone" placeholder="请输入来访人手机号码" />
        </el-form-item>
         <el-form-item>
          <el-select
            v-model="searchForm.regStuats"
            placeholder="请选择来访状态"
            clearable
            @clear="queryXzRegisterPage"
          >
            <el-option
              v-for="(item, index) in regStuats"
              :key="index"
              :label="item.catName"
              :value="item.catName"
            />
          </el-select>
        </el-form-item> 
        <el-form-item>
          <!-- <el-button @click="cancelData">重置</el-button> -->
          <el-button type="primary" @click="queryXzRegisterPage">搜 索</el-button>
        </el-form-item>
      </el-form>
      <el-button type="success" @click="addType" class="turnBule">添加访问</el-button>
    </SearchForm>
  
    <TableContainer title="">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        border
        :header-cell-style="tabHeader"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="organizationName" label="接待信息" min-width="60">
          <template slot-scope="scope">
            <div class="t-l">
              <p>接待部门：{{ scope.row.organizationName || "--" }}</p>
              <p>接待人：{{ scope.row.fullName || "--" }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="regName" label="来访信息" min-width="110">
          <template slot-scope="scope">
            <div class="t-l">
              <p>
                <el-tag v-show="scope.row.regStuats !== null" type="danger">{{
                  scope.row.regStuats
                }}</el-tag
                >{{ scope.row.regName }}
                <span style="margin-left: 10px">{{ scope.row.regCard }}</span>
              </p>
              <p>来访手机：{{ scope.row.regPhone }}</p>
              <p>来访车牌：{{ scope.row.regCar || "--" }}</p>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="regName" label="来访事项" min-width="100">
          <template slot-scope="scope">
            <div class="t-l">
              <p>来访公司:{{ scope.row.regCompany || "--" }}</p>
              <p>来访业务:{{ scope.row.business || "--" }}</p>
              <p>来访事由:{{ scope.row.reason || "--" }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="60" />
        <el-table-column prop="createtime" label="登记时间" min-width="60" />
        <el-table-column prop="regTime" label="预约进厂时间 " min-width="60" />
        <el-table-column width="200" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="textOrange"
              @click="editorFormClick(scope.row)"
              v-show="scope.row.regStuats !== '已登记'"
              >编辑</el-button
            >
            <el-button type="text" class="textOrange" @click="delXzRegister(scope.row)"
              >删除</el-button
            >
            <el-button
              type="text"
              class="textOrange"
              @click="checkPxCatpx(scope.row)"
              v-show="scope.row.regStuats !== '已登记'"
              >待核销</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <GPagination
        v-show="total > 0"
        ref="ref_GPagination"
        :total="total"
        :page.sync="searchForm.page"
        :size.sync="searchForm.size"
        @pagination="queryXzRegisterPage"
      />
    </TableContainer>

    <!-- 新增/编辑分类s -->
    <GDialog
      :dialog.sync="catDialog"
      @btnSure="catSubmitThemeForm()"
      @btnClose="resetThemeForm()"
      width="50%"
      :showCloseBtn="false"
      :showFooter="true"
    >
      <el-form ref="ref_themeForm" label-width="100px" @submit.native.prevent>
        <div class="dis-flex flex-x-start flex-y-start">
          <div class="dis-flex flex-x-start flex-y-start">
            <el-form-item label="接待部门" label-width="80px">
              <el-select
                v-model="pxParmas.organizationId"
                placeholder="请选择部门"
                @change="(val) => partChangeType(val)"
                filterable
                allow-create
                default-first-option
              >
                <el-option
                  v-for="(item, index) in partList"
                  :key="index"
                  :label="item.organizationName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </div>
          <div
            class="dis-flex flex-x-start flex-y-start"
            style="margin-left: 20px"
            v-show="pxParmas.organizationId !== '' && pxParmas.organizationId !== null"
          >
            <el-form-item label="接待人" label-width="60px">
              <el-select v-model="pxParmas.userId" placeholder="请选择"
                 filterable
                allow-create
                default-first-option
              >
                <el-option
                  v-for="(item, index) in peoples"
                  :key="index"
                  :label="item.fullName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label-width="20px">
            <el-radio v-model="pxParmas.regStuats" label="已预约">已预约</el-radio>
            <el-radio v-model="pxParmas.regStuats" label="临时">临时</el-radio>
          </el-form-item>
        </div>
        <div class="dis-flex flex-x-between flex-y-start">
          <div class="dis-flex flex-x-start flex-y-start">
            <p class="m-top15 col-red">*</p>
            <el-form-item label="来访人" label-width="60px" class="t-c">
              <el-input
                v-model="pxParmas.regName"
                maxlength="35"
                placeholder="请输入"
                style="width: 210px"
              />
            </el-form-item>
          </div>
          <div class="dis-flex flex-x-start flex-y-start">
            <p class="m-top15 col-red">*</p>
            <el-form-item label="身份证" label-width="60px" class="t-c">
              <el-input
                v-model="pxParmas.regCard"
                maxlength="35"
                placeholder="请输入"
                style="width: 210px"
              />
            </el-form-item>
          </div>
          <div class="dis-flex flex-x-start flex-y-start">
            <p class="m-top15 col-red">*</p>
            <el-form-item label="手机号码" label-width="80px" class="t-c">
              <el-input
                v-model="pxParmas.regPhone"
                maxlength="35"
                placeholder="请输入"
                style="width: 210px"
              />
            </el-form-item>
          </div>
        </div>

        <div class="dis-flex flex-x-between flex-y-start">
          <div class="dis-flex flex-x-start flex-y-start">
            <el-form-item label="来访公司" label-width="70px" class="t-c">
              <el-input
                v-model="pxParmas.regCompany"
                maxlength="35"
                placeholder="请输入"
                style="width: 210px"
              />
            </el-form-item>
          </div>
          <div class="dis-flex flex-x-start flex-y-start">
            <el-form-item label="车牌" label-width="60px" class="t-c">
              <el-input
                v-model="pxParmas.regCar"
                maxlength="35"
                placeholder="请输入"
                style="width: 210px"
              />
            </el-form-item>
          </div>
          <div class="dis-flex flex-x-start flex-y-start">
            <p class="m-top15 col-red">*</p>
            <el-form-item label="进厂时间" label-width="80px" class="t-c">
              <el-date-picker
                v-model.trim="pxParmas.regTime"
                type="date"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                @change="selectTime"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </div>

        <div class="dis-flex flex-x-start flex-y-start">
          <p class="m-top15 col-red">*</p>
          <el-form-item label="进厂事由" label-width="80px">
            <textarea
              id="content"
              name="content"
              rows="3"
              cols="80"
              style="width: 100%; border: 1px solid #58e3e8"
              v-model="pxParmas.reason"
            ></textarea>
          </el-form-item>
        </div>
        <div class="dis-flex flex-x-start flex-y-start">
          <!-- <p class="m-top15 col-red">*</p> -->
          <el-form-item label="业务" label-width="90px">
            <textarea
              id="content"
              name="content"
              rows="3"
              cols="80"
              style="width: 100%; border: 1px solid #58e3e8"
              v-model="pxParmas.business"
            ></textarea>
          </el-form-item>
        </div>
        <div class="dis-flex flex-x-start flex-y-start">
          <!-- <p class="m-top15 col-red">*</p> -->
          <el-form-item label="备注" label-width="90px">
            <textarea
              id="content"
              name="content"
              rows="3"
              cols="80"
              style="width: 100%; border: 1px solid #58e3e8"
              v-model="pxParmas.remark"
            ></textarea>
          </el-form-item>
        </div>
      </el-form>
    </GDialog>
    <!--  新增/编辑分类e -->
  </section>
</template>

<script>
import {
  queryXzRegisterPage,
  delPxCat,
  selectDcDept,
  selectMinDcDept,
  addXzRegister,
  updateXzRegister,
  delXzRegister,
  findDeptUser,
} from "@api/bx/api_contentManagement";
import uploadPics from "@/components/Upload/uploadPics.vue";
import uploadList from "@/components/Upload/uploadList.vue";
export default {
  components: { uploadPics, uploadList },
  data() {
    return {
      tiny: {
        value: undefined,
      },
      themeDialog: {
        title: "信息框",
        visible: false,
      },
      catDialog: {
        title: "分类操作",
        visible: false,
      },
      searchForm: {
        page: 1,
        size: 10,
        regName:'',
        regStuats:''
      },
      regStuats:[
        {
          catName:'临时',
      },
      {
          catName:'已预约',
      },
      {
          catName:'已登记',
      },
      ],
      total: 0,
      tableData: [],
      editor: 0,
      typeList: [],
      partList: [],
      checkedCities: [],
      noticeTitle: "",
      partName: "",
      roleId: "",
      catInfo: "",
      content: "",
      pxParmas: {
        organizationId: "",
        userId: "",
        regStuats: "已预约",
        regName: "",
        regPhone: "",
        regCard: "",
        regCompany: "",
        regCar: "",
        regTime: "",
        reason: "",
        business: "",
        reason: "",
        remark: "",
      },
      partList: [],
      peoples: [],
      id: "",
    };
  },
  created() {
    this.queryXzRegisterPage();
    this.selectMinDcDept();
    // this.selectDcDept();
    // this.selectMinDcDept();
  },
  methods: {
    tabHeader() {
      return "backgroundColor:rgba(88, 227, 232, 0.12);color:#000;font-weight:bold;font-size:15px;text-align: center;";
    },
    //时间筛选
    selectTime(val) {
      if (val == null) {
        this.pxParmas.regTime = "";
      } else {
        this.pxParmas.regTime = val;
      }
    },
    //部门查询
    selectMinDcDept() {
      selectMinDcDept({}).then((res) => {
        this.partList = res;
      });
    },
    // handleClearPart() {
    //   this.pxParmas.organizationId = "";
    // },
    findDeptUser(id) {
      findDeptUser({ estimatedAttributionId: id }).then(
        (res) => {
          this.peoples = res;
        }
      );
    },
    partChangeType() {
      this.findDeptUser(this.pxParmas.organizationId);
    },

    handleCheckedCitiesChange(val) {
      console.log(val);
    },
    resetThemeForm() {
      this.editor = 0;
      this.pxParmas.organizationId ='';
      this.pxParmas.userId = '';
      this.pxParmas.regStuats = '已预约';
      this.pxParmas.regName = '';
      this.pxParmas.regPhone = '';
      this.pxParmas.regCard = '';
      this.pxParmas.regCompany = '';
      this.pxParmas.regCar = '';
      this.pxParmas.regTime = '';
      this.pxParmas.reason = '';
      this.pxParmas.business = '';
      this.pxParmas.reason = '';
      this.pxParmas.remark = '';
      this.id = '';
      this.catDialog.visible = false;
    },
    // 部门列表
    // selectDcDept() {
    //   selectDcDept({}).then((res) => {
    //     this.typeList = res;
    //   });
    // },
    //多部门列表
    // selectMinDcDept() {
    //   selectMinDcDept({}).then((res) => {
    //     this.partList = res;
    //   });
    // },
    // 初始化列表
    queryXzRegisterPage() {
      queryXzRegisterPage(this.searchForm).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    //分类新增,编辑
    catSubmitThemeForm() {
      if (this.pxParmas.regName == "") {
        this.$message.warning("请填写来访人姓名");
        return;
      }
      if (this.pxParmas.regCard == "") {
        this.$message.warning("请填写来访人身份证");
        return;
      }
      if (this.pxParmas.regPhone == "") {
        this.$message.warning("请填写来访人手机号码");
        return;
      }
      if (this.pxParmas.regTime == "") {
        this.$message.warning("请选择进厂时间");
        return;
      }
      if (this.pxParmas.reason == "") {
        this.$message.warning("请选择进厂事由");
        return;
      }

      if (this.editor == "0") {
        // return
        //首次提交
        addXzRegister(this.pxParmas).then((res) => {
          this.$message.success("新增分类成功");
          this.resetThemeForm();
          this.queryXzRegisterPage();
        });
      } else {
        //编辑提交
        updateXzRegister({
          id: this.id,
          business: this.pxParmas.business,
          organizationId: this.pxParmas.organizationId,
          reason: this.pxParmas.reason,
          regAdress: this.pxParmas.regAdress,
          regCar: this.pxParmas.regCar,
          regCard: this.pxParmas.regCard,
          regCompany: this.pxParmas.regCompany,
          regName: this.pxParmas.regName,
          regPhone: this.pxParmas.regPhone,
          regStuats: this.pxParmas.regStuats,
          regTime: this.pxParmas.regTime,
          remark: this.pxParmas.remark,
          userId: this.pxParmas.userId,
          id: this.id,
        }).then((res) => {
          this.$message.success("编辑成功");
          this.resetThemeForm();
          this.queryXzRegisterPage();
        });
      }
    },
    //添加
    addType() {
      this.catDialog.visible = true;
    },
    //编辑
    editorFormClick(row) {
      this.findDeptUser(row.organizationId)
      this.editor = 1;
      this.pxParmas.organizationId = row.organizationId;
      this.pxParmas.userId = row.userId;
      this.pxParmas.regStuats = row.regStuats;
      this.pxParmas.regName = row.regName;
      this.pxParmas.regPhone = row.regPhone;
      this.pxParmas.regCard = row.regCard;
      this.pxParmas.regCompany = row.regCompany;
      this.pxParmas.regCar = row.regCar;
      this.pxParmas.regTime = row.regTime;
      this.pxParmas.reason = row.reason;
      this.pxParmas.business = row.business
      this.pxParmas.reason = row.reason;
      this.pxParmas.remark = row.remark;
      this.id = row.id;
      this.catDialog.visible = true;
    },

    //去核销
    checkPxCatpx(row) {
      this.$confirm("核销【" + row.regName + "】这条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateXzRegister({
          id: row.id,
          business: row.business,
          organizationId: row.organizationId,
          reason: row.reason,
          regAdress: row.regAdress,
          regCar: row.regCar,
          regCard: row.regCard,
          regCompany: row.regCompany,
          regName: row.regName,
          regPhone: row.regPhone,
          regStuats: "已登记",
          regTime: row.regTime,
          remark: row.remark,
          userId: row.userId,
        }).then((res) => {
          this.queryXzRegisterPage();
        });
      });
    },

    //删除
    delXzRegister(row) {
      this.$confirm("永久删除【" + row.regName + "】这条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delXzRegister({ id: row.id }).then((res) => {
          this.queryXzRegisterPage();
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
/* .tree /deep/ .el-tree-node__content{
		padding-left: 40px
	} */
.turnBule {
  color: #fff;
  background-color: #58e3e8;
  border-color: rgba(56, 185, 190, 0.12);
  margin-left: 15px;
}

.turnBule:hover,
.turnBule:focus {
  background: rgba(56, 185, 190, 0.5);
  border-color: rgba(56, 185, 190, 0.5);
  color: #fff;
}

.el-button--text.reviewed {
  color: #38b9be;
}

.reviewed {
  color: #38b9be;
}

.el-tree-node__content {
  z-index: 999;
  padding-left: 40px;
}

.directory-in {
  width: 32%;
  line-height: 60px;
  background: #4095e5;
}
</style>
